export const shadowStyles = {
  shadow1: `0px 15px 75px -6px rgba(0, 0, 0, 0.38)`,
  shadow2: `0 3px 4px hsla(0,0%,63.1%,.4)`,
  shadow3: `box-shadow: 0px 30px 40px rgba(143, 143, 143, 0.26), 0px 10px 20px rgba(161, 161, 161, 0.37);`,
  shadow3alt: `0px 30px 30px rgba(0, 0, 0, 0.13)`,
  shadow4: `0px 40px 50px rgba(0, 0, 0, 0.2)`,
  shadowBlack: `0px 4px 40px rgba(0, 0, 0, 0.25)`,
  shadowNoHover: `0 2px 6px 1px rgba(0,0,0,.2)`,
  shadowHover: `0 20px 45px -6px rgba(0,0,0,.2)`,
}
